import React, { FC, useState } from 'react';

import { BUTTON_TYPES, EvButton, EvSvgIcon, Info } from '@evinced-private/ui-common';

import { ComponentDetailsPopup } from '../component-details-popup/ComponentDetailsPopup';
import { IssueDetailsPopup } from '../issue-details-popup/IssueDetailsPopup';

import './ShowDetailsCellFormatter.scss';

interface IShowDetailsCellFormatterCell {
	issue: { id: string; url?: string };
	rowId: string;
	scanId?: string;
	componentDetails?: { componentId: string; totalPages: number; totalIssues: number };
}
export const ShowDetailsCellFormatter: FC<IShowDetailsCellFormatterCell> = ({
	issue,
	rowId,
	scanId,
	componentDetails
}: IShowDetailsCellFormatterCell) => {
	const [isModalOpen, setModalOpen] = useState(false);

	const openModal = async (): Promise<void> => {
		setModalOpen(true);
	};

	let componentsPopupComponent;
	if (componentDetails) {
		componentsPopupComponent = (
			<ComponentDetailsPopup
				componentId={componentDetails.componentId}
				issueId={issue.id}
				onClose={() => setModalOpen(false)}
				scanId={scanId}
				totalPages={componentDetails.totalPages}
				totalIssues={componentDetails.totalIssues}
			/>
		);
	}

	return (
		<div className="show-details-cell">
			<EvButton
				ariaLabel={`${rowId} show details`}
				customTooltip={{ renderTooltip: true }}
				type={BUTTON_TYPES.ICON}
				onClick={openModal}
				ariaHaspopup="dialog"
			>
				<EvSvgIcon icon={Info} isSmall />
			</EvButton>
			{isModalOpen && !componentDetails ? (
				<IssueDetailsPopup issueId={issue.id} onClose={() => setModalOpen(false)} scanId={scanId} />
			) : null}
			{isModalOpen && componentDetails ? componentsPopupComponent : null}
		</div>
	);
};
